<template>
  <paginated-list :actions="actions" :columns="columns" no-results-message="" service="experiences">
    <template v-slot:top>
      <p>
        We assess and continue to monitor the track-record of our borrowers to allow us to make our lending decisions.
        It is important that the information provided is accurate as we will review and confirm any information given with third party sources where possible.
      </p>
    </template>
    <template v-slot:none>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <form @submit.prevent="submit">
            <base-card>
              <p>
                If you have no current experience, please select below.
              </p>
              <base-checkbox v-model="payload.experience.non">
                I have no development experience to add
              </base-checkbox>
              <base-checkbox v-model="payload.experience.nonDeveloper">
                I have experience but not as a developer
              </base-checkbox>
              <base-textarea
                v-model="payload.experience.info"
                class="mt-3 mb-0"
                placeholder="Please tell us about your experience."/>
              <template v-slot:footer>
                <div class="text-right">
                  <base-button
                    :loading="saving"
                    icon-right="arrow-right"
                    primary
                    submit>
                    Submit
                  </base-button>
                </div>
              </template>
            </base-card>
          </form>
        </div>
      </div>
    </template>
  </paginated-list>
</template>

<script>
import PaginatedList from './PaginatedList.vue'

export default {
  name: 'ExperienceFilter',

  components: {
    PaginatedList
  },

  created () {
    this.payload.experience = this.$_.clone(this.$auth.user.profile.experience) || {
      non: false,
      nonDeveloper: false,
      info: ''
    }
  },

  data: () => ({
    payload: {},
    saving: false
  }),

  computed: {
    actions () {
      return [{
        role: 'borrower',
        text: 'Edit',
        to: {
          name: 'experience.edit'
        }
      }, {
        role: 'admin',
        text: 'Review',
        to: {
          name: 'experience.review'
        }
      }]
    },

    columns () {
      return {
        name: 'Project',
        units: 'Units',
        startedAt: 'Started At',
        completedAt: 'Completed At',
        'financials.gdv': {
          header: 'GDV',
          format: ({ financials }) => this.$formatting.toCurrency(financials.gdv)
        },
        'financials.grossProfit': {
          header: 'Gross Profit',
          format: ({ financials }) => this.$formatting.toCurrency(financials.grossProfit)
        },
        'financials.netProfit': {
          header: 'Net Profit',
          format: ({ financials }) => this.$formatting.toCurrency(financials.netProfit)
        }
      }
    }
  },

  methods: {
    async submit () {
      this.saving = true

      await this.$store.dispatch('core/auth/update-profile', {
        _id: this.$auth.user.profile._id,
        ...this.payload
      })

      this.saving = false

      this.$flash.success('Information submitted.')
    }
  }
}
</script>
